module.exports = __webpack_public_path__ + "media/website/badge-341e25dd.png";